import React from 'react';
import OpportunityStatus from '@/constants/OpportunityStatus';
import type { OpportunitiesDataListRow } from '@/modules/Opportunities/';

const useConstituentFilteredOpportunities = (
  opportunities: OpportunitiesDataListRow[],
  statusFilters: Record<OpportunityStatus, boolean>,
) => {
  return React.useMemo(
    () =>
      opportunities.filter(({ archivedAt }) => {
        if (archivedAt && statusFilters[OpportunityStatus.ARCHIVED]) {
          return true;
        }

        if (!archivedAt && statusFilters[OpportunityStatus.ACTIVE]) {
          return true;
        }

        return false;
      }),
    [opportunities, statusFilters],
  );
};

export default useConstituentFilteredOpportunities;
